import React from 'react';

import Entrance from './sharedUnpackeNewsComponents/Entrance';
import NewsListItem from './sharedUnpackeNewsComponents/NewsListItem';
import NewsListItemOnChannel from './sharedUnpackeNewsComponents/NewsListItemOnChannel';
import NewsListItemRead from './sharedUnpackeNewsComponents/NewsListItemRead';

interface IProps {
  listImage: string;
  subjectText: string;
  iconImage: string;
  isCaptionDisplay: boolean;
  movie: number;
  isDiscovery?: boolean;
}

export default class ListImagePreviews extends React.PureComponent<IProps> {
  public render() {
    const { listImage, subjectText, iconImage, isCaptionDisplay, movie, isDiscovery = false } = this.props;

    return (
      <div className="list-image-previews">
        <Entrance
          listImage={listImage}
          text={isCaptionDisplay ? subjectText : ''}
          movie={movie}
          isDiscovery={isDiscovery}
        />
        <NewsListItem
          listImage={listImage}
          text={subjectText}
          iconImage={iconImage}
          movie={movie}
        />
        <NewsListItemOnChannel
          listImage={listImage}
          text={subjectText}
          movie={movie}
        />
        <NewsListItemRead
          listImage={listImage}
          text={subjectText}
          iconImage={iconImage}
          movie={movie}
          isDiscovery={isDiscovery}
        />
      </div>
    );
  }
}
